import { apiClient } from './client';
import type { AdminPermission, AdminRole, PermissionMatrix } from '@/types/admin-permission';

interface PermissionsResponse {
  data: AdminPermission[];
}

interface RolesResponse {
  data: AdminRole[];
}

interface UpdateRoleResponse {
  success: boolean;
  role: AdminRole;
}

export async function getPermissions(): Promise<AdminPermission[]> {
  const response = await apiClient.get<PermissionsResponse>('/api/admin/permissions');
  return response.data.data;
}

export async function getRoles(): Promise<AdminRole[]> {
  const response = await apiClient.get<RolesResponse>('/api/admin/permissions/roles');
  return response.data.data;
}

export async function getPermissionMatrix(): Promise<PermissionMatrix> {
  const response = await apiClient.get<PermissionMatrix>('/api/admin/permissions/matrix');
  return response.data;
}

export async function updateRolePermissions(
  roleCode: string,
  permissions: string[]
): Promise<AdminRole> {
  const response = await apiClient.put<UpdateRoleResponse>(
    `/api/admin/permissions/roles/${roleCode}`,
    { permissions }
  );
  return response.data.role;
}
